/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledModalBox } from '../../blogs/styles';
import SuccessStoryNewEditForm from 'src/sections/@dashboard/successStory/SuccessStoryNewEditForm';
import { SuccessStory } from '../../../../@types/successStory';

type SuccessStoryModalProps = {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentStory: SuccessStory | undefined;
};

export const SuccessStoryModal = ({
  open,
  handleClose,
  isEdit,
  currentStory,
}: SuccessStoryModalProps) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledModalBox>
        <SuccessStoryNewEditForm
          handleClose={handleClose}
          isEdit={isEdit}
          currentStory={currentStory}
        />
      </StyledModalBox>
    </Modal>
  );
};
